const initialState = {
  schForm: {
    schTp: "",
    storeCode: "",
  },
  data: "",
  loading: false,
};

export const LOADING = "LOADING";
export const loadingAction = (data) => ({
  type: LOADING,
  payload: data,
});

export const SET_FORM = "SET_FORM";
export const schFormAction = (data) => ({
  type: SET_FORM,
  payload: data,
});

export const LOAD_MAIN = "LOAD_MAIN";
export const loadMainAction = (data) => ({
  type: LOAD_MAIN,
  payload: data,
});

export const LOAD_MAIN_SUCCESS = "LOAD_MAIN_SUCCESS";
export const loadDataSuccessAction = (list) => ({
  type: LOAD_MAIN_SUCCESS,
  payload: list,
});

export const RESET_MAIN = "RESET_MAIN";
export const resetMain = (data) => ({
  type: RESET_MAIN,
  payload: data,
});

export default function HomeReducer(state = initialState, action) {
  const { type, payload, error } = action;

  console.log("homeReducer = type", type, "payload", payload);

  switch (type) {
    case LOADING:
      return {
        ...state,
        loading: payload,
      };
    case SET_FORM:
      return {
        ...state,
        schForm: payload,
      };
    case LOAD_MAIN:
      return {
        ...state,
        schForm: payload,
      };
    case LOAD_MAIN_SUCCESS:
      return {
        ...state,
        data: payload,
      };
    case RESET_MAIN:
      return {
        ...state,
        data: "",
      };
    default:
      return state;
  }
}
